/**
 * DO NOT MANUALLY EDIT THIS FILE
 * This file is generated automatically by the build script on prebuild step.
 * Please refer to documentation for more information
 */

export default function MetaCategories({ children }) {
  return children({
    art: [
      'drawings',
      'paintings',
      'pop-art',
      'photography',
      'collage',
      'collage/photo',
      'abstract',
      'prints',
      'drawings/botanical/flower',
      'sculpture',
      'photography/portraits',
      'paintings/fabric',
      'paintings/oil',
      'photography/nudes',
      'prints/cityscapes/london',
      'drawings/cartoon',
      'prints/lino',
      'drawings/animals',
      'conceptual',
      'nudes',
      'photography/fashion',
      'street-art',
      'digital',
      'photography/still-life',
      'paintings/abstract',
      'abstract-expressionism',
      'photography/food',
      'paintings/landscapes',
      'paintings/botanical/flower',
      'drawings/animals/bird',
      'drawings/transport-auto/car',
      'landscapes',
      'landscapes/sky',
      'photography/wildlife',
      'photography/nature',
      'prints/botanical',
      'photography/black-white',
      'photography/documentary',
      'photography/botanical/tree',
      'photography/architecture',
      'drawings/pencil',
      'impressionistic',
      'photography/abstract',
      'still-life',
      'installation',
      'paintings/acrylic',
      'nature',
      'graphic',
      'stencil',
      'mosaic',
      'fantasy',
      'paintings/abstract-marble',
      'photography/surrealist',
      'prints/animals',
      'paintings/cityscapes/london',
      'drawings/realistic',
      'dada',
      'geometric',
      'minimalistic',
      'sports/football',
      'photorealism',
      'photography/conceptual',
      'photography/urban',
      'photography/botanical/flower',
      'photography/animals/dog',
      'photography/cityscapes/london',
      'photography/sports',
      'paintings/botanical/tree',
      'paintings/nudes',
      'drawings/charcoal',
      'typography',
      'portraits',
      'drawings/nature',
      'politics',
      'botanical/leaves',
      'prints/botanical/leaves',
      'sculpture/clay',
      'digital/vector',
      'sculpture/ceramic',
      'art-deco',
      'paintings/still-life',
      'drawings/ink',
      'drawings/animals/horse',
      'drawings/food',
      'cartoon',
      'figurative',
      'animals',
      'botanical/flower',
      'still-life/flower',
      'urban',
      'wildlife',
      'botanical',
      'photography/pinhole',
      'sculpture/wood',
      'sculpture/metal',
      'photography/animals',
      'photography/transport-auto/car',
      'prints/maps',
      'paintings/animals',
      'drawings/still-life',
      'drawings/animals/cat',
      'sculpture/bronze',
      'animals/horse',
      'food',
      'still-life/food',
      'paintings/encaustic',
      'prints/art-deco',
      'prints/typography',
      'prints/botanical/flower',
      'prints/cityscapes/new-york',
      'paintings/animals/bird',
      'drawings/cityscapes/london',
      'botanical/tree',
      'spirituality/religion',
      'paintings/seascapes',
      'drawings/botanical/tree',
      'drawings/animals/dog',
      'surrealist',
      'paintings/nature',
      'music',
      'photography/underwater',
      'sculpture/paper',
      'sculpture/glass',
      'sculpture/kinetic',
      'paintings/landscapes/beach',
      'drawings/crayon',
      'photography/animals/bird',
      'photography/animals/horse',
      'prints/geometric',
      'prints/animals/dog',
      'paintings/animals/cat',
      'paintings/animals/dog',
      'drawings/pastel',
      'drawings/celebrities',
      'drawings/botanical',
      'sculpture/animals/horse',
      'animals/cat',
      'animals/cow',
      'animals/fish',
      'fashion',
      'maps',
      'sports/cycling',
      'paintings/animals/horse',
      'drawings/landscapes',
      'drawings/music',
      'sculpture/plastic',
      'abstract-marble',
      'prints/abstract-marble',
      'photography/mixed-media',
      'prints/abstract',
      'prints/urban',
      'prints/landscapes',
      'paintings/animals/fish',
      'drawings/geometric',
      'drawings/nudes',
      'sculpture/animals',
      'expressionistic',
      'animals/dog',
      'landscapes/beach',
      'prints/mono',
      'sculpture/resin',
      'paintings/portraits',
      'drawings/animals/fish',
      'prints/fantasy',
      'prints/animals/bird',
      'prints/fashion',
      'paintings/realistic',
      'paintings/art-deco',
      'drawings/chalk',
      'drawings/illustrative',
      'sculpture/stone',
      'sculpture/abstract',
      'sculpture/botanical/tree',
      'cubism',
      'prints/graphic',
      'photography/landscapes/beach',
      'transport-auto/yacht',
      'paintings/transport-auto/yacht',
      'sculpture/marble',
      'prints/pop-art',
      'prints/animals/fish',
      'prints/cityscapes/paris',
      'paintings/cityscapes/new-york',
      'paintings/food',
      'paintings/spirituality/religion',
      'drawings/abstract',
      'cityscapes/new-york',
      'spirituality',
      'drawings/architecture',
      'drawings/wildlife',
      'drawings/stencil',
      'drawings/fantasy',
      'underwater',
      'paintings/colour-field',
      'geometric-abstract',
      'transport-auto/ship',
      'paintings/transport-auto/ship',
      'photography/animals/cat',
      'photography/cityscapes/paris',
      'collage/animals',
      'prints/woodcut',
      'prints/botanical/tree',
      'prints/animals/horse',
      'prints/music',
      'prints/transport-auto/car',
      'paintings/cartoon',
      'paintings/figurative',
      'paintings/cityscapes/paris',
      'sculpture/animals/cat',
      'cityscapes/paris',
      'sports',
      'prints/screenprint',
      'drawings/portraits',
      'realistic',
      'photography/fantasy',
      'prints/landscapes/beach',
      'photography/cityscapes',
      'photography/celebrities',
      'collage/mixed-media',
      'collage/paper',
      'prints/etching',
      'paintings/pop-art',
      'paintings/geometric',
      'drawings/pop-art',
      'sculpture/animals/bird',
      'architecture',
      'photography/seascapes',
      'collage/cityscapes/london',
      'paintings/wildlife',
      'prints/nature',
      'photography/pop-art',
      'photography/street-art',
      'collage/landscapes',
      'paintings/mixed-media',
      'paintings/underwater',
      'drawings/cityscapes/new-york',
      'cityscapes',
      'seascapes',
      'sculpture/nature',
      'paintings/photorealism',
      'paintings/botanical/leaves',
      'drawings/underwater',
      'collage/pop-art',
      'paintings/architecture',
      'cityscapes/london',
      'landscapes/rural',
      'prints/wildlife',
      'collage/nature',
      'drawings/graphic',
      'paintings/music',
      'photography/geometric',
      'photography/cubism',
      'paintings/cityscapes',
      'paintings/maps',
      'paintings/ink',
      'celebrities',
      'maps/london',
      'paintings/botanical',
      'photography/botanical',
      'prints/mosaic',
      'illustrative',
      'cityscapes/hong-kong',
      'animals/bird',
      'paintings/mosaic',
      'paintings/abstract-expressionism',
      'cityscapes/singapore',
      'paintings/graphic',
      'paintings/politics',
      'paintings/portraits/male',
      'transport-auto/airplane',
      'documentary',
      'prints/transport-auto/yacht',
      'prints/transport-auto/ship',
      'prints/politics',
      'colour-field',
      'paintings/portraits/female',
      'drawings/portraits/female',
      'maps/new-york',
      'prints/abstract-expressionism',
      'drawings/photorealism',
      'paintings/fantasy',
      'drawings/portraits/male',
      'science-technology',
      'transport-auto',
      'paintings/geometric-abstract',
      'prints/geometric-abstract',
      'photography/landscapes',
      'prints/cartoon',
      'installation/figurative',
      'collage/figurative',
      'drawings/figurative',
      'photography/figurative',
      'prints/figurative',
      'sculpture/figurative',
      'prints/conceptual',
      'paintings/conceptual',
      'collage/conceptual',
      'drawings/conceptual',
      'sculpture/conceptual',
      'drawings/cubism',
      'paintings/cubism',
      'sculpture/cubism',
      'collage/dada',
      'prints/dada',
      'sculpture/dada',
      'collage/expressionistic',
      'drawings/expressionistic',
      'paintings/expressionistic',
      'photography/expressionistic',
      'prints/expressionistic',
      'sculpture/expressionistic',
      'collage/geometric',
      'installation/geometric',
      'sculpture/geometric',
      'collage/illustrative',
      'paintings/illustrative',
      'photography/illustrative',
      'prints/illustrative',
      'sculpture/illustrative',
      'collage/impressionistic',
      'drawings/impressionistic',
      'paintings/impressionistic',
      'photography/impressionistic',
      'prints/impressionistic',
      'sculpture/impressionistic',
      'collage/minimalistic',
      'drawings/minimalistic',
      'installation/minimalistic',
      'paintings/minimalistic',
      'photography/minimalistic',
      'prints/minimalistic',
      'sculpture/minimalistic',
      'collage/realistic',
      'photography/realistic',
      'prints/realistic',
      'sculpture/realistic',
      'collage/street-art',
      'drawings/street-art',
      'installation/street-art',
      'paintings/street-art',
      'prints/street-art',
      'sculpture/street-art',
      'collage/surrealist',
      'drawings/surrealist',
      'paintings/surrealist',
      'prints/surrealist',
      'sculpture/surrealist',
      'drawings/transport-auto/airplane',
      'paintings/transport-auto/airplane',
      'prints/transport-auto/airplane',
      'transport-auto/bike',
      'prints/transport-auto/bike',
      'transport-auto/car',
      'collage/transport-auto/car',
      'transport-auto/train',
      'paintings/transport-auto/train',
      'photography/transport-auto/train',
      'prints/transport-auto/train',
      'collage/fabric',
      'paintings/airbrush',
      'paintings/gouache',
      'paintings/tempera',
      'paintings/watercolour',
      'photography/digital',
      'prints/lithograph',
      'prints/mixed-media',
      'photography/colour',
      'photography/black-white',
      'pop-art/portraits',
      'abstract/portraits',
      'photography/landscapes/sky',
      'photography/black-white/portraits',
      'prints/digital',
      'cubism/portraits',
      'paintings/abstract/botanical/flower',
      'abstract/landscapes',
      'impressionistic/portraits',
      'drawings/realistic/animals',
      'photography/cityscapes/new-york',
      'prints/animals/cat',
      'geometric/animals',
      'expressionistic/portraits',
      'abstract/seascapes',
      'paintings/abstract/landscapes',
      'paintings/oil/seascapes',
      'photography/botanical/leaves',
      'photography/cityscapes/hong-kong',
      'photography/abstract/portraits',
      'photography/portraits/female',
      'photography/black-white/landscapes',
      'prints/sports/cycling',
      'abstract/animals',
      'abstract/botanical/flower',
      'abstract/botanical/tree',
      'portraits/female',
      'digital/abstract',
      'drawings/pencil/animals',
      'paintings/abstract/animals',
      'photography/abstract/landscapes',
      'photography/black-white/botanical/flower',
      'photography/black-white/nudes',
      'photography/colour/portraits',
      'prints/seascapes',
      'surrealist/portraits',
      'drawings/pencil/realistic',
      'paintings/abstract/seascapes',
      'paintings/spirituality',
      'photography/black-white/animals',
      'prints/nudes',
      'sculpture/art-deco',
      'abstract/nature',
      'paintings/fashion',
      'paintings/landscapes/sky',
      'photography/black-white/architecture',
      'impressionistic/landscapes',
      'cartoon/portraits',
      'paintings/impressionistic/landscapes',
      'photography/abstract/architecture',
      'photography/landscapes/rural',
      'photography/transport-auto',
      'portraits/male',
      'drawings/urban',
      'drawings/pencil/abstract',
      'paintings/celebrities',
      'paintings/oil/landscapes',
      'paintings/watercolour/abstract',
      'photography/dada',
      'photography/portraits/male',
      'sculpture/nudes',
      'realistic/portraits',
      'paintings/transport-auto',
      'paintings/urban',
      'paintings/oil/abstract',
      'photography/spirituality/religion',
      'photography/transport-auto/bike',
      'prints/architecture',
      'prints/portraits',
      'sculpture/animals/fish',
      'surrealist/landscapes',
      'photorealism/portraits',
      'paintings/dada',
      'paintings/still-life/flower',
      'paintings/oil/nudes',
      'paintings/oil/still-life',
      'photography/graphic',
      'photography/conceptual/portraits',
      'photography/spirituality',
      'prints/food',
      'sculpture/landscapes',
      'abstract/architecture',
      'abstract/landscapes/beach',
      'graphic/portraits',
      'street-art/portraits',
      'drawings/maps',
      'drawings/pencil/landscapes',
      'paintings/impressionistic/botanical/flower',
      'paintings/sports',
      'paintings/abstract/still-life',
      'paintings/oil/animals/horse',
      'prints/celebrities',
      'prints/maps/london',
      'prints/sports',
      'abstract/animals/bird',
      'abstract/nudes',
      'geometric/landscapes',
      'pop-art/landscapes',
      'geometric/portraits',
      'collage/animals/horse',
      'collage/botanical/flower',
      'drawings/cityscapes',
      'drawings/landscapes/sky',
      'installation/urban',
      'paintings/pop-art/animals',
      'paintings/art-deco/landscapes',
      'paintings/realistic/landscapes',
      'paintings/impressionistic/still-life',
      'paintings/realistic/still-life',
      'paintings/acrylic/abstract',
      'paintings/oil/animals',
      'paintings/watercolour/landscapes',
      'photography/abstract/fashion',
      'photography/minimalistic/landscapes',
      'photography/minimalistic/portraits',
      'photography/black-white/wildlife',
      'photography/colour/documentary',
      'prints/cityscapes',
      'prints/science-technology',
      'prints/spirituality/religion',
      'prints/still-life',
      'prints/lino/animals',
      'sculpture/portraits',
      'cartoon/animals',
      'graphic/animals',
      'minimalistic/animals',
      'abstract/animals/fish',
      'abstract/botanical',
      'abstract/botanical/leaves',
      'abstract/cityscapes',
      'impressionistic/cityscapes',
      'pop-art/cityscapes',
      'abstract/fashion',
      'abstract-expressionism/landscapes',
      'art-deco/landscapes',
      'expressionistic/landscapes',
      'minimalistic/landscapes',
      'realistic/landscapes',
      'abstract/maps',
      'abstract-expressionism/portraits',
      'conceptual/portraits',
      'figurative/portraits',
      'minimalistic/portraits',
      'impressionistic/seascapes',
      'abstract/still-life',
      'abstract/urban',
      'street-art/urban',
      'realistic/wildlife',
      'collage/abstract',
      'collage/graphic',
      'collage/portraits',
      'collage/sports',
      'digital/surrealist',
      'digital/portraits',
      'drawings/abstract/landscapes',
      'drawings/landscapes/rural',
      'drawings/realistic/portraits',
      'drawings/seascapes',
      'drawings/charcoal/realistic',
      'drawings/charcoal/animals',
      'drawings/charcoal/nudes',
      'drawings/ink/abstract',
      'drawings/ink/animals',
      'drawings/ink/botanical',
      'drawings/ink/nudes',
      'drawings/pastel/nudes',
      'drawings/pencil/botanical',
      'drawings/pencil/portraits',
      'drawings/pencil/realistic/portraits',
      'drawings/pencil/urban',
      'installation/typography',
      'paintings/abstract/animals/bird',
      'paintings/realistic/animals/bird',
      'paintings/realistic/animals/horse',
      'paintings/abstract/architecture',
      'paintings/abstract/botanical',
      'paintings/realistic/botanical/flower',
      'paintings/abstract/botanical/leaves',
      'paintings/abstract/cityscapes',
      'paintings/abstract/nudes',
      'paintings/impressionistic/nudes',
      'paintings/realistic/nudes',
      'paintings/abstract-expressionism/landscapes',
      'paintings/expressionistic/landscapes',
      'paintings/minimalistic/landscapes',
      'paintings/abstract/landscapes/beach',
      'paintings/landscapes/rural',
      'paintings/abstract/landscapes/sky',
      'paintings/abstract/nature',
      'paintings/abstract/portraits',
      'paintings/impressionistic/portraits',
      'paintings/pop-art/portraits',
      'paintings/realistic/portraits',
      'paintings/science-technology',
      'paintings/abstract/spirituality',
      'paintings/expressionistic/still-life',
      'paintings/still-life/food',
      'paintings/typography',
      'paintings/acrylic/realistic',
      'paintings/acrylic/animals',
      'paintings/acrylic/animals/bird',
      'paintings/acrylic/botanical/flower',
      'paintings/acrylic/nudes',
      'paintings/acrylic/landscapes',
      'paintings/acrylic/abstract/landscapes',
      'paintings/acrylic/landscapes/beach',
      'paintings/acrylic/seascapes',
      'paintings/acrylic/still-life',
      'paintings/gouache/abstract',
      'paintings/ink/abstract',
      'paintings/mixed-media/abstract',
      'paintings/oil/art-deco',
      'paintings/oil/figurative',
      'paintings/oil/geometric',
      'paintings/oil/impressionistic',
      'paintings/oil/pop-art',
      'paintings/oil/realistic',
      'paintings/oil/animals/bird',
      'paintings/oil/animals/fish',
      'paintings/oil/botanical',
      'paintings/oil/botanical/flower',
      'paintings/oil/abstract/botanical/flower',
      'paintings/oil/botanical/tree',
      'paintings/oil/celebrities',
      'paintings/oil/cityscapes',
      'paintings/oil/cityscapes/london',
      'paintings/oil/cityscapes/paris',
      'paintings/oil/fantasy',
      'paintings/oil/abstract/landscapes',
      'paintings/oil/impressionistic/landscapes',
      'paintings/oil/realistic/landscapes',
      'paintings/oil/landscapes/beach',
      'paintings/oil/nature',
      'paintings/oil/portraits',
      'paintings/oil/spirituality',
      'paintings/oil/sports',
      'paintings/oil/realistic/still-life',
      'paintings/oil/urban',
      'paintings/watercolour/realistic',
      'paintings/watercolour/animals',
      'photography/abstract-expressionism',
      'photography/abstract/cityscapes',
      'photography/surrealist/fashion',
      'photography/impressionistic/landscapes',
      'photography/abstract/seascapes',
      'photography/minimalistic/seascapes',
      'photography/black-white/botanical',
      'photography/black-white/celebrities',
      'photography/black-white/cityscapes',
      'photography/black-white/documentary',
      'photography/black-white/portraits/female',
      'photography/black-white/seascapes',
      'photography/colour/abstract',
      'photography/colour/nudes',
      'photography/colour/landscapes',
      'photography/digital/abstract',
      'photography/digital/landscapes',
      'photography/digital/portraits',
      'prints/abstract/animals',
      'prints/cartoon/animals',
      'prints/pop-art/animals',
      'prints/abstract/botanical',
      'prints/abstract/landscapes',
      'prints/landscapes/rural',
      'prints/spirituality',
      'prints/lithograph/abstract',
      'prints/lithograph/botanical',
      'prints/lithograph/landscapes',
      'sculpture/abstract/animals',
      'sculpture/realistic/animals',
      'sculpture/architecture',
      'sculpture/botanical',
      'sculpture/music',
      'sculpture/spirituality',
      'sculpture/still-life',
      'sculpture/urban',
      'sculpture/bronze/abstract',
      'sculpture/bronze/animals',
      'sculpture/bronze/nudes',
      'sculpture/ceramic/abstract',
      'sculpture/metal/abstract',
      'sculpture/metal/animals',
      'sculpture/metal/animals/bird',
      'sculpture/paper/abstract',
      'sculpture/stone/abstract',
      'sculpture/wood/abstract',
      'digital/vector/fashion',
      'prints/animals/cow',
      'photography/colour/fantasy',
      'paintings/animals/cow',
      'paintings/sports/football',
      'paintings/transport-auto/car',
      'paintings/abstract/botanical/tree',
      'paintings/watercolour/seascapes',
      'sculpture/spirituality/religion',
      'paintings/cubism/still-life',
      'paintings/oil/animals/dog',
      'sculpture/pop-art',
      'sculpture/fashion',
      'paintings/stencil',
      'paintings/abstract/animals/dog',
      'paintings/abstract/animals/fish',
      'paintings/realistic/botanical/tree',
      'paintings/pop-art/food',
      'paintings/cubism/landscapes',
      'paintings/abstract/music',
      'paintings/impressionistic/nature',
      'paintings/photorealism/still-life',
      'paintings/pop-art/still-life',
      'paintings/transport-auto/bike',
      'paintings/abstract/transport-auto/car',
      'paintings/acrylic/wildlife',
      'paintings/oil/cartoon',
      'paintings/oil/photorealism',
      'paintings/oil/animals/cat',
      'paintings/oil/animals/cow',
      'paintings/oil/cityscapes/new-york',
      'paintings/oil/music',
      'paintings/oil/abstract/music',
      'paintings/oil/spirituality/religion',
      'paintings/oil/sports/football',
      'paintings/oil/transport-auto/car',
      'paintings/oil/transport-auto/ship',
      'paintings/oil/transport-auto/train',
      'paintings/oil/underwater',
      'paintings/oil/wildlife',
      'paintings/watercolour/animals/bird',
      'paintings/watercolour/botanical/flower',
      'paintings/watercolour/still-life',
      'sculpture/abstract-expressionism',
      'sculpture/cartoon',
      'sculpture/celebrities',
      'sculpture/fantasy',
      'sculpture/politics',
      'sculpture/sports',
      'sculpture/transport-auto/airplane',
      'sculpture/bronze/animals/horse',
      'sculpture/ceramic/figurative',
      'sculpture/clay/figurative',
      'sculpture/enamel',
      'sculpture/paper/geometric',
      'sculpture/wood/animals',
      'digital/fashion',
      'photography/music',
      'drawings/fashion',
      'drawings/botanical/leaves',
      'photography/sports/cycling',
      'drawings/cartoon/animals',
      'drawings/spirituality',
      'abstract/music',
      'photography/black-white/still-life',
      'collage/architecture',
      'photography/minimalistic/architecture',
      'photography/transport-auto/yacht',
      'photography/black-white/abstract',
      'drawings/politics',
      'photography/sports/athletics',
      'photography/abstract/still-life',
      'photography/black-white/botanical/tree',
      'photography/science-technology',
      'photography/sports/football',
      'drawings/landscapes/beach',
      'photography/abstract/nature',
      'prints/stencil',
      'collage/animals/bird',
      'drawings/charcoal/abstract',
      'drawings/pencil/still-life',
      'photography/colour/food',
      'prints/lino/landscapes',
      'conceptual/landscapes',
      'graphic/landscapes',
      'sports/athletics',
      'abstract/transport-auto/car',
      'collage/still-life',
      'digital/realistic',
      'drawings/abstract-expressionism',
      'drawings/geometric-abstract',
      'drawings/abstract/botanical/tree',
      'drawings/charcoal/landscapes',
      'drawings/pastel/abstract',
      'drawings/pencil/animals/bird',
      'drawings/pencil/seascapes',
      'photography/abstract/nudes',
      'photography/conceptual/landscapes',
      'photography/abstract/landscapes/beach',
      'photography/black-white/landscapes/beach',
      'photography/black-white/music',
      'prints/cubism',
      'prints/photorealism',
      'sculpture/graphic',
    ],
    artist: [
      'austrian',
      'australian',
      'belgian',
      'brazilian',
      'canadian',
      'colombian',
      'cuban',
      'german',
      'spanish',
      'french',
      'british',
      'greek',
      'irish',
      'israeli',
      'indian',
      'italian',
      'jamaican',
      'japanese',
      'mexican',
      'nigerian',
      'dutch',
      'norwegian',
      'polish',
      'russian',
      'swedish',
      'american',
      'collagists',
      'digital',
      'installation',
      'painters',
      'painters/impressionistic',
      'photographers',
      'photographers/female',
      'photographers/abstract',
      'photographers/surrealist',
      'printmakers',
      'sculptors',
      'sculptors/female',
      '',
      'african',
      'asian',
      'caribbean',
      'european',
      'latin-american',
      'scandinavian',
      'abstract',
      'abstract/female',
      'art-deco',
      'cartoon',
      'conceptual',
      'cubism',
      'dada',
      'expressionistic',
      'figurative',
      'geometric',
      'graphic',
      'illustrative',
      'impressionistic',
      'impressionistic/female',
      'minimalistic',
      'photorealism',
      'pop-art',
      'pop-art/female',
      'realistic',
      'street-art',
      'surrealist',
      'surrealist/female',
    ],
  });
}
